import styled from 'styled-components';
import {
  GameDefList,
  GameDD,
  GameDT,
} from '../GameSelector/GameSelector.styled';

export const Title = styled.h2`
  color: ${props => props.theme.colors.tertiary};
  font-size: calc(25px + 1.75vmin);
  line-height: 0.9;
  margin: 0 20px;
  text-transform: uppercase;
  z-index: 10;

  span:nth-child(even) {
    position: relative;
    top: -3px;
  }
`;

export const Details = styled.span`
  position: relative;
  font-size: calc(16px + 1vmin);
`;

export const ResultDefList = styled(GameDefList)`
  display: grid;
  grid-gap: 0;
  grid-template-columns: 50% 25% 25%;
  margin: 40px auto 10px;
  max-width: 180px;
  width: 100%;

  dd:nth-child(2),
  dd:nth-child(3) {
    border-bottom: 1px dotted ${props => props.theme.colors.greyBorder};
  }

  dd:nth-child(3)::before {
    content: 'BEST';
    font-size: 9px;
    left: 50%;
    letter-spacing: 1px;
    opacity: 0.5;
    position: absolute;
    right: 5px;
    top: -15px;
    transform: translateX(-50%);
    width: 100%;
  }
`;

export const ResultDD = styled(GameDD)`
  background: ${props => (props.PB ? props.theme.colors.light : 'transparent')};
  box-shadow: ${props =>
    props.PB ? 'inset 3px 0 0 rgba(0,0,0,0.02)' : 'none'};
  border-left: 1px dotted ${props => props.theme.colors.greyBorder};
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.5vmin);
  margin: 0;
  padding: 5px;
  text-align: center;

  .result-enter-done & {
    opacity: 1;
  }
`;

export const ResultDT = styled(GameDT)`
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.5vmin);
  margin: 0;
  padding: 5px;
  text-align: center;

  &:first-of-type {
    border-bottom: 1px dotted ${props => props.theme.colors.greyBorder};
  }

  .result-enter-done & {
    opacity: 1;
  }
`;

const RoundResultsStyled = styled.section`
  background: ${props => props.theme.colors.white};
  box-shadow: 10px 10px rgba(81, 40, 166, 0.5);
  border-radius: 10px;
  color: ${props => props.theme.colors.tertiary};
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: center;
  min-height: 320px;
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 56%;
  transform: ${props =>
    props.gameOver
      ? 'translate(-50%, -50%) rotateY(90deg)'
      : 'translate(-50%, 50%)'};
  transition: transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.cubicBez},
    opacity ${props => props.theme.transition.durationLong};
  transition-delay: ${props =>
    props.gameOver ? '0s' : props.theme.result.delay};
  width: 75%;
  z-index: ${props => (props.show ? '10' : '-1')};

  .result-enter-done & {
    opacity: 1;
    transform: translate(-50%, -50%) rotateY(0);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    min-height: 345px;
    width: 85%;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    min-height: 370px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    height: 58%;
    top: 50%;
    width: 45%;
    max-width: 380px;
    min-height: 410px;
    min-width: 390px;
  }
`;

export default RoundResultsStyled;



// WEBPACK FOOTER //
// ./src/components/organisms/RoundResults/RoundResults.styled.js